import videojs from "video.js";
import { QualityLevel } from "../model/qualityLevel/QualityLevel";

// This file may be later converted to a plugin

function getPlayerTech(player: videojs.Player) {
  return (player.tech({ IWillNotUseThisInPlugins: true }) as any).vhs;
}

export function getQualityLevels(player: videojs.Player): QualityLevel[] {
  const tech = getPlayerTech(player);

  const currentRepresentationId = tech.selectPlaylist().id;
  const representations = tech.representations();

  return representations
    .map(
      (representation) =>
        new QualityLevel(
          representation.id,
          representation.width,
          representation.height,
          representation.bandwidth,
          representation.id === currentRepresentationId,
        ),
    )
    .sort((r1, r2) => r1.bandwidth - r2.bandwidth);
}

export function getCurrentQualityLevel(player: videojs.Player): QualityLevel | null {
  return getQualityLevels(player).find((qualityLevel) => qualityLevel.isCurrent);
}

export function setAllowedQualityLevels(player: videojs.Player, qualityLevel: QualityLevel) {
  const tech = getPlayerTech(player);

  const correspondingRepresentation = tech.representations().find((representation) => {
    return representation.width === qualityLevel.width && representation.height === qualityLevel.height;
  });

  if (correspondingRepresentation !== undefined) {
    correspondingRepresentation.enabled(true);
  }

  return correspondingRepresentation;
}

export function prebufferingSupported(player: videojs.Player) {
  return (player.tech({ IWillNotUseThisInPlugins: true }) as any).vhs !== undefined;
}
